import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConfigProvider } from '../base/config'
import { Observable } from 'rxjs/Observable'
import { map } from 'rxjs/operators'

/*
 Generated class for the AgendamentoProvider provider.

 See https://angular.io/guide/dependency-injection for more info on providers
 and Angular DI.
 */
@Injectable()
export class AgendamentoProvider {
  public ressourceUrl: any =
    ConfigProvider.host + '/api/v1/front/saude/agendamento'

  constructor(public http: HttpClient) {}

  agendar(
    data,
    params: any = {},
    headers: HttpHeaders = null
  ): Observable<any> {
    return this.http
      .post(this.ressourceUrl + '/realizar-agendamento', data, {
        params: params,
        headers: headers
      })
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  reagendar(
    horario,
    agendamento,
    params: any = {},
    headers: HttpHeaders = null
  ): Observable<any> {
    return this.http
      .get(this.ressourceUrl + `/reagendar/${horario}/${agendamento}`, {
        params: params,
        headers: headers
      })
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  historico(params: any = {}, headers: HttpHeaders = null): Observable<any> {
    return this.http
      .get(this.ressourceUrl, {
        params: params,
        headers: headers
      })
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  cancelar(id, params: any = {}, headers: HttpHeaders = null): Observable<any> {
    return this.http
      .get(this.ressourceUrl + '/cancelar/' + id, {
        params: params,
        headers: headers
      })
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  nextPage(_url: string = ''): Observable<any> {
    let options = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Enctype: 'application/json'
      }
    }

    return this.http.get(_url, options)
  }
}



// WEBPACK FOOTER //
// ./src/providers/agendamento/agendamento.ts